import apiResponse from './ApiResponse';
import { ApiService } from './ApiService';
import { Group } from '@models';

export class PledgePotStore {
  constructor(private readonly api: ApiService = new ApiService()) {}

  public async getPledgePot(groupId: number) {
    try {
      const result = await this.api.get(`Cohort/${groupId}/pot`);
      return apiResponse.Success<PledgePot>(result);
    } catch (e) {
      return apiResponse.HandleError(e);
    }
  }
}
export type PledgePot = {
  potAmount: number;
};
